import { z } from 'zod';
import { HouseholdId, IsoDatetime, LangCode, StaffMessageId, UserId } from './primitives.js';

export const CreateStaffMessageRequest = z.object({
  body: z.string().min(1).max(2000),
  source_lang: LangCode,
  // One per submit — see migration 0039. Lets a repeat delivery (the
  // offline queue replaying this exact POST) land as the same message
  // rather than a second one.
  idempotency_key: z.string().max(64).optional(),
});

export const StaffMessage = z.object({
  id: StaffMessageId,
  household_id: HouseholdId,
  author_user_id: UserId,
  body: z.string(),
  source_lang: LangCode,
  created_at: IsoDatetime,
});
